<div class="step-box">
    <div class="col-lg-12">
        <section>
            <nav>
                <ul class="nav nav-tabs">
                    @for (traitModel of selectedTraitModels; track traitModel.variableId) {
                        <li class="nav-item pe-1 mt-1">
                            <a class="nav-link p-2"
                               [routerLink]="[{outlets:{'display-result-outlet': 'variableId/' + traitModel.variableId}}]"
                               [routerLinkActive]="['active']"
                               queryParamsHandling="merge">
                                <truncate-span [textInput]="traitModel.variableName" [maxLength]="20" [showCopyButton]="false"></truncate-span>
                            </a>
                        </li>
                    }
                </ul>
            </nav>
            <div class="tab-content p-3">
                <router-outlet name="display-result-outlet"></router-outlet>
            </div>
        </section>
    </div>
    <div class="row mt-3">
        <div class="col-md-12 text-center">
            <button class="btn btn-secondary ms-2" (click)="prevStep()" jhiTranslate="back">Back</button>
            <button class="btn btn-primary ms-2" (click)="export($event)" [disabled]="isLoading">
                <span *ngIf="isLoading" class="throbber throbber-btn"></span>{{ 'export' | translate }}
            </button>
        </div>
    </div>
</div>
